import { useLanguage } from '../hooks/useLanguage';

const useTranslate = (translations) => {
  const language = useLanguage();

  return translations[language];
};

export default useTranslate;
